import type { ServiceOrderDTO } from "@/models/dtos/service-order-dto";
import { http } from "./http";
import type { CreateServiceOrderRequest } from "@/models/requests/create-service-order-request";
import { notificationsService } from "./notifications-service";
import { authService } from "@/services/auth-service";

class ServiceOrdersService {
  async getServiceOrders(params?: Record<string, unknown>) {
    const authHeader = await authService.getAuthHeader();
    return http
      .url("/service-orders")
      .auth(authHeader)
      .query(params ?? {})
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ServiceOrderDTO[]>();
  }

  async getServiceOrder(id: number | string) {
    const authHeader = await authService.getAuthHeader();
    return http
      .url(`/service-orders/${id}`)
      .auth(authHeader)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ServiceOrderDTO>();
  }

  async getServiceOrderFile(
    serviceOrderId: number | undefined,
    fileId: number | string,
  ) {
    const authHeader = await authService.getAuthHeader();
    return http
      .url(`/service-orders/${serviceOrderId}/file/${fileId}`)
      .auth(authHeader)
      .get()
      .blob();
  }

  async getServiceOrderFiles(
    serviceOrderId: number | undefined,
    params?: Record<string, unknown>,
  ) {
    const authHeader = await authService.getAuthHeader();
    return http
      .url(`/service-orders/${serviceOrderId}/file/zip`)
      .auth(authHeader)
      .query(params ?? {})
      .get()
      .fetchError((err) => notificationsService.error(err))
      .blob();
  }

  async createServiceOrder(
    request: CreateServiceOrderRequest,
  ): Promise<ServiceOrderDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .url("/service-orders")
      .auth(authHeader)
      .post(request)
      .fetchError((err) => notificationsService.error(err))
      .json<ServiceOrderDTO>();
  }

  async addFile(
    serviceOrderId: number | string,
    formData: FormData | Record<string, any>,
  ) {
    const authHeader = await authService.getAuthHeader();
    await http
      .url(`/service-orders/${serviceOrderId}/file`)
      .auth(authHeader)
      .formData(formData)
      .post()
      .fetchError((err) => notificationsService.error(err))
      .res();
  }

  // async addFile(serviceOrderId: number | string, fileInput: File) {
  //   const authHeader = await authService.getAuthHeader();
  //
  //   // Create a new FormData and explicitly add the file with 'file' key
  //   const formData = new FormData();
  //   formData.append('file', fileInput);
  //
  //   console.log('FormData:', formData);
  //   console.log(formData.values())
  //   console.log('File:', fileInput);
  //   console.log(formData.get('file'));
  //
  //   return http
  //     .url(`/service-orders/${serviceOrderId}/file`)
  //     .auth(authHeader)
  //     .formData(formData) // Pass the FormData object directly
  //     .post()
  //     .fetchError((err) => notificationsService.error(err))
  //     .res();
  // }
  //
  // async addFile(
  //   serviceOrderId: number | string,
  //   fileInput: File                   // <- accept a true File here
  // ) {
  //   // build the real FormData here
  //   const formData = new FormData();
  //   formData.append('file', fileInput);
  //
  //   const authHeader = await authService.getAuthHeader();
  //
  //   await http
  //     .url(`/service-orders/${serviceOrderId}/file`)
  //     .auth(authHeader)
  //     .formData(formData)               // now it's guaranteed to be FormData
  //     .post()
  //     .fetchError(err => notificationsService.error(err))
  //     .res();
  // }
}

export const serviceOrdersService = new ServiceOrdersService();
